// extracted by mini-css-extract-plugin
module.exports = {"monthDay":"jjEo8","weekDay":"_3qrdb","month":"eQsUE","listHeaderTitle":"_1prb8","color":"_288sy"};